export default __webpack_public_path__ + "static/media/clients-landing-8.c9b81003.jpg";